import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DischargeConditions } from "../Types/Project/DefaultService/DischargeConditionInterface";

interface DischargeConditionState {
    dischargeConditions: DischargeConditions[];
    loading: boolean;
    error: string | null;
    selectedDischargeCondition: DischargeConditions | null;
}

const initialState: DischargeConditionState = {
    dischargeConditions: [],
    loading: false,
    error: null,
    selectedDischargeCondition: null
}

const dischargeConditionSlice = createSlice ({
    name: 'dischargeConditions',
    initialState,
    reducers: {
        fetchDischargeConditionsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchDischargeConditionsSuccess: (state, action: PayloadAction<DischargeConditions[]>) => {
            state.loading = false;
            state.dischargeConditions = action.payload;
        },
        fetchDischargeConditionsFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },

        setSelectedDischargeCondition: (state, action: PayloadAction<DischargeConditions>) => {
            state.selectedDischargeCondition = action.payload;
        },

        fetchDischargeConditionSuccessAndSetSelectedDischargeCondition: (state, action: PayloadAction<any[]>) => {
            state.loading = false;
            state.dischargeConditions = action.payload;

            const previousSelectedId = state.selectedDischargeCondition?.id;
            if (previousSelectedId) {
                state.selectedDischargeCondition = state.dischargeConditions.find(oneData => oneData.id === previousSelectedId) || null;
            } else {
                state.selectedDischargeCondition = null; // Or set to the first oneData in the list, etc.
            }
        },
    }
});

export const { fetchDischargeConditionsStart, fetchDischargeConditionsSuccess, fetchDischargeConditionsFailure, setSelectedDischargeCondition, fetchDischargeConditionSuccessAndSetSelectedDischargeCondition } = dischargeConditionSlice.actions;
export default dischargeConditionSlice.reducer;